import { render, staticRenderFns } from "./PeopleIdea.vue?vue&type=template&id=7ac69242&"
import script from "./PeopleIdea.vue?vue&type=script&lang=js&"
export * from "./PeopleIdea.vue?vue&type=script&lang=js&"
import style0 from "./PeopleIdea.vue?vue&type=style&index=0&id=7ac69242&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports